import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UiTooltipComponent} from '@ui/modules/ui-tooltip/ui-tooltip.component';

@NgModule({
  declarations: [
    UiTooltipComponent
  ],
  exports: [
    UiTooltipComponent
  ],
  imports: [
    CommonModule
  ]
})
export class UiTooltipModule {
}
